export default "__VITE_ASSET__cfae3b1f__"